import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useOktaAuth } from '@LaSalle-invest/okta-mfe-auth/react';
import type { UseOktaAuthReturn } from '@LaSalle-invest/okta-mfe-auth/react';

/**
 * Handles the Okta callback after authentication redirect.
 * The okta-mfe-auth library handles the token exchange automatically.
 * This component redirects to the original URI after successful authentication.
 */
export function OktaCallback() {
  const navigate = useNavigate();
  const { isAuthenticated, isLoading, error } =
    useOktaAuth() as UseOktaAuthReturn<Record<string, unknown>>;

  useEffect(() => {
    if (isLoading) return;

    if (error) {
      console.error('[Chatbot] Okta callback error:', error);
      return;
    }

    if (isAuthenticated) {
      // Redirect to the stored URI or home
      const storedUri = sessionStorage.getItem('preAuthUri') || '/';
      sessionStorage.removeItem('preAuthUri');
      navigate(storedUri, { replace: true });
    }
  }, [isAuthenticated, isLoading, error, navigate]);

  if (error) {
    return (
      <div>
        <div>Authentication callback error</div>
        <pre>{error.message}</pre>
      </div>
    );
  }

  return <div>Processing authentication...</div>;
}
